import PropTypes from 'prop-types';
import React from 'react';

import './SliderChart.scss';

export default class SliderChart extends React.PureComponent {
    constructor(props) {
        super();
    }

    static propTypes = {
        /**
         * rating number
         */
        rating: PropTypes.number,
        /**
         * size of icons
         */
        size: PropTypes.string,
        /**
         * total Rating
         */
        totalRating: PropTypes.number,
    };

    static defaultProps = {
        totalRating: 5,
        totalWidth: 5 * 48,
        size: 'small',
    };

    getRatingWidth = () => {
        const { totalRating, rating, totalWidth } = this.props;
        return (rating / totalRating) * 100;
    };

    render() {
        const { size } = this.props;
        const numbers = [];

        for (let i = 0; i < 5; i++) {
            numbers.push(
                <div
                    key={i + 1}
                    className={`number number-${i + 1} ${
                        this.props.rating === i + 1 ? 'bold' : ''
                    }`}
                >
                    {i + 1}
                </div>
            );
        }

        return (
            <div className={`component-Charts-SliderChart `}>
                <div className={`sliding-chart ${size} d-flex`}>
                    <div className="section">
                        <div className="gray" />
                        <div
                            className="purple"
                            style={{ width: `${this.getRatingWidth()}%` }}
                        />
                        <div className="whiteBorderSection d-flex">
                            <div className="white" />
                            <div className="white" />
                            <div className="white" />
                            <div className="white" />
                            <div className="white" />
                        </div>
                        <div className="numberSection d-flex">{numbers}</div>
                    </div>
                </div>
            </div>
        );
    }
}
